package com.partejar.app.core.ui.theme

import androidx.compose.material3.Typography
import androidx.compose.runtime.Composable
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.sp
import org.jetbrains.compose.resources.Font
import partejar_app.shared.generated.resources.Res
import partejar_app.shared.generated.resources.quicksand_variable

@Composable
internal fun partejarTypography(): Typography {
    val quicksand = FontFamily(
        Font(Res.font.quicksand_variable, weight = FontWeight.Normal),
        Font(Res.font.quicksand_variable, weight = FontWeight.Medium),
        Font(Res.font.quicksand_variable, weight = FontWeight.SemiBold),
        Font(Res.font.quicksand_variable, weight = FontWeight.Bold)
    )

    return Typography(
        displayLarge = textStyle(quicksand, FontWeight.Bold, 48, 56),
        displayMedium = textStyle(quicksand, FontWeight.Bold, 40, 48),
        displaySmall = textStyle(quicksand, FontWeight.Bold, 36, 44),
        headlineLarge = textStyle(quicksand, FontWeight.SemiBold, 32, 40),
        headlineMedium = textStyle(quicksand, FontWeight.SemiBold, 28, 36),
        headlineSmall = textStyle(quicksand, FontWeight.SemiBold, 24, 32),
        titleLarge = textStyle(quicksand, FontWeight.SemiBold, 22, 28),
        titleMedium = textStyle(quicksand, FontWeight.SemiBold, 18, 24),
        titleSmall = textStyle(quicksand, FontWeight.SemiBold, 16, 22),
        bodyLarge = textStyle(quicksand, FontWeight.Normal, 16, 24),
        bodyMedium = textStyle(quicksand, FontWeight.Normal, 14, 20),
        bodySmall = textStyle(quicksand, FontWeight.Normal, 12, 18),
        labelLarge = textStyle(quicksand, FontWeight.SemiBold, 14, 20),
        labelMedium = textStyle(quicksand, FontWeight.SemiBold, 12, 16),
        labelSmall = textStyle(quicksand, FontWeight.Medium, 11, 16)
    )
}

private fun textStyle(
    fontFamily: FontFamily,
    fontWeight: FontWeight,
    fontSize: Int,
    lineHeight: Int
) = TextStyle(
    fontFamily = fontFamily,
    fontWeight = fontWeight,
    fontSize = fontSize.sp,
    lineHeight = lineHeight.sp
)
